import React from "react";
import logoregular from "../img/background_main.jpg"

const Home = () => {
	return (<div id="home" className="home-container">
		<span className="home-container_header-wrapper">
			<div>
				<h2 className="home-container_main-header">Shibinlal Purushothaman</h2>
				<label className="home-container_sub-header">Software engineer</label>
			</div>
		</span>
		<picture>
			<source srcSet={logoregular} media="(max-width: 768px)" />
			<source srcSet={logoregular} media="(min-width: 768px)" />
			<source srcSet={logoregular} media="(min-width: 1920px)" />
			<img alt="work in progress" src={logoregular} />
		</picture>
	</div>);
};

export default Home;

